<div class="image-container">
    <img src="../../../assets/images/SMRT-Logic-PIN.jpg" alt="">
</div>
